module.exports = __webpack_public_path__ + "img/1.45f4222e.jpg";